import {DA_SUCCESS} from '../get-audits/constants'
import {deleteAudit as deleteAuditAPI} from '../../../services/audits'

export async function deleteAudit(id, dispatch) {
  try {
    let response = await deleteAuditAPI(id)
    dispatch({type: DA_SUCCESS, payload: id})
    return response
  } catch (e) {
    console.log(`Delete Audit Failed: ${e}`)
    return e.response
  }
}
